import React, { FC, HTMLAttributes } from 'react';

import { useProductCardContext } from '../../../context/ProductCardContext';
import lg from './lg.svg';
import md from './md.svg';
import sm from './sm.svg';
import { Root } from './ZigzinExpress.styled';

const ICON_LOOKUP = {
  md,
  sm,
  lg,
};

const ICON_SIZE_LOOKUP = {
  md: {
    width: 46,
    height: 12,
  },
  sm: {
    width: 30,
    height: 20,
  },
  lg: {
    width: 47,
    height: 20,
  },
};

export interface ZigzinExpressProps extends HTMLAttributes<HTMLImageElement> {
  /**
   * 아이콘 사이즈 (혹은 타입)
   * sm: 소형 그리드 형태의 상품 카드
   * md: 리스트 형태의 상품 카드
   * lg: 대형 그리드 형태의 상품 카드
   */
  size: 'sm' | 'md' | 'lg';
}

/**
 * 직진배송 아이콘 컴포넌트
 */
export const ZigzinExpress: FC<React.PropsWithChildren<ZigzinExpressProps>> = ({ size, ...rest }) => {
  const { is_zonly } = useProductCardContext();
  if (!is_zonly) {
    return null;
  }
  return <Root {...rest} {...ICON_SIZE_LOOKUP[size]} src={ICON_LOOKUP[size]} alt='직진 배송' />;
};
